import type { ParsedUrlQuery } from 'querystring';

/**
 * Converts Next.js router query object to URLSearchParams
 * Handles both string and array values
 */
export const buildQueryParamsFromRouter = (query: ParsedUrlQuery): URLSearchParams => {
  const queryString = Object.entries(query)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return `${key}=${value.join(',')}`;
      }
      return `${key}=${value}`;
    })
    .join('&');

  return new URLSearchParams(queryString);
};

/**
 * Builds a new URL path without a specific query parameter
 */
export const buildUrlWithoutParam = (
  pathname: string,
  query: ParsedUrlQuery,
  paramToRemove: string,
): string => {
  const queryParams = buildQueryParamsFromRouter(query);
  queryParams.delete(paramToRemove);

  const newQueryString = queryParams.toString();
  return newQueryString ? `${pathname}?${newQueryString}` : pathname;
};
